import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { excluirAlerta } from "./services";
import { toast } from "sonner";

interface ExcluirParams {
  id: number;
  fisico: boolean;
}

export const actionExcluirAlerta = createAsyncThunk(
  "alertas/excluir",
  async ({ id, fisico }: ExcluirParams, { rejectWithValue }) => {
    try {
      const response = await excluirAlerta(id, fisico);
      if (response === "ok") {
        const msg = fisico
          ? "Alerta apagado permanentemente!"
          : "Alerta desativado com sucesso!";
        toast.success(msg);
        return id;
      }
      return rejectWithValue(response);
    } catch (err: any) {
      toast.error("Erro ao processar exclusão.");
      return rejectWithValue(err.message);
    }
  },
);

const sliceExcluirAlerta = createSlice({
  name: "excluirAlerta",
  initialState: { loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(actionExcluirAlerta.pending, (state) => {
        state.loading = true;
      })
      .addCase(actionExcluirAlerta.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(actionExcluirAlerta.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default sliceExcluirAlerta.reducer;
